import OrdersListForReturn from '@components/account/OrdersListForReturn';
import ReturnsGuestForm from '@moncler/components/clientService/ReturnsGuestForm';
import { OrdersActionTypes } from '@state/features/common.types';
import { getReturnableOrders } from '@state/features/orders.selectors';
import Button from '@ui/button/Button';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Section from '@common/components/common/Section';
import { addURLParameter } from '@common/utils/urlutils';
const ReturnsOrdersListing = (props) => {
    const { t } = useTranslation();
    const { loading, orders } = useSelector(getReturnableOrders);
    const dispatch = useDispatch();
    const [order, setOrder] = useState();
    const goToReturnPage = (order) => {
        let newUrl = addURLParameter(props.openreturnurl, 'orderId', order.orderNumber);
        window.location.href = addURLParameter(newUrl, 'token', order.token);
    };
    useEffect(() => {
        if (loading) {
            dispatch({
                type: OrdersActionTypes.FETCH_ORDERS,
            });
        }
    }, []);
    if (loading) {
        return React.createElement(React.Fragment, null);
    }
    if (orders.length === 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Section, { className: "no-order-found", title: `${t('returns.noorderfound')}`, description: t('returns.youdonthaveorders'), introSection: true },
                React.createElement("a", { href: props.orderspageurl, className: "button button--secondary" },
                    React.createElement("span", null, t('button.findorder')))),
            React.createElement(ReturnsGuestForm, Object.assign({}, props, { isExchange: props.onlyEligibleForExchange, loggedUser: true }))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, { noMargin: true, title: props.title, description: props.description, introSection: true }),
        React.createElement(OrdersListForReturn, { callback: (order) => setOrder(order), onlyreturnable: true, hideButtons: true, inReturn: true, onlyEligibleForExchange: props.onlyEligibleForExchange, orderNumberActive: order === null || order === void 0 ? void 0 : order.orderNumber }),
        React.createElement(Button, { type: "button", onClick: () => goToReturnPage(order), cls: ['button--primary'], disabled: !order }, t('button.proceed'))));
};
export default ReturnsOrdersListing;
